/**
 * FeesTab Component
 * Program fee structure
 */

import React from 'react';
import styles from './TabStyles.module.css';

const FeesTab = ({ program }) => {
  const registrationFees = program?.cost?.registrationFees || [];
  const feeStructure = program?.cost?.feeStructure || [];

  return (
    <div className={styles.tabContainer}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Fee Structure</h3>
        
        {/* Registration Fees */}
        <div className={styles.feeSection}>
          <h4 className={styles.feeSectionTitle}>Registration Fees</h4>
          {registrationFees.length > 0 ? (
            registrationFees.map((fee, index) => (
              <div key={index} className={styles.feeItem}>
                <p className={styles.feeAmount}>Amount: ${fee.amount}</p>
                {fee.discount?.percentage && (
                  <p className={styles.feeDiscount}>
                    Discount: {fee.discount.percentage}%
                    {fee.discount.validUntil && 
                      ` (Valid until ${new Date(fee.discount.validUntil).toLocaleDateString()})`
                    }
                  </p>
                )}
                <p className={styles.feeValid}>
                  Valid: {new Date(fee.startDate).toLocaleDateString()} -{' '}
                  {new Date(fee.endDate).toLocaleDateString()}
                </p>
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>No registration fees available.</p>
          )}
        </div>

        {/* Regular Fees */}
        <div className={styles.feeSection}>
          <h4 className={styles.feeSectionTitle}>Regular Fees</h4>
          {feeStructure.length > 0 ? (
            feeStructure.map((fee, index) => (
              <div key={index} className={styles.feeItem}>
                <p className={styles.feeAmount}>
                  {fee.interval}: ${fee.amount}
                </p>
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>No fee structure available.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default FeesTab;










